/* ZOALIN_MOBILE_FOOTER_FIXED_SIZE_20260720 */
(function () {
  var mq = window.matchMedia('(max-width: 749px), (pointer: coarse) and (orientation: landscape) and (max-height: 760px)');
  var timer = 0;

  function setImportant(el, styles) {
    if (!el) return;
    Object.keys(styles).forEach(function (key) {
      el.style.setProperty(key, styles[key], 'important');
    });
  }

  function place(el, column, row) {
    setImportant(el, { 'grid-column': column, 'grid-row': row });
  }

  function findByText(root, text) {
    if (!root) return null;
    var nodes = root.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i += 1) {
      if ((nodes[i].textContent || '').replace(/\s+/g, ' ').indexOf(text) !== -1) return nodes[i];
    }
    return null;
  }

  function topChild(root, el) {
    if (!root || !el) return null;
    var node = el;
    while (node && node.parentElement && node.parentElement !== root) {
      node = node.parentElement;
    }
    return node && node.parentElement === root ? node : el;
  }

  function applyFooterSize() {
    if (!mq.matches) return;
    document.documentElement.setAttribute('data-zoalin-mobile-footer-fixed-size', '20260720');

    Array.prototype.forEach.call(document.querySelectorAll('footer'), function (footer) {
      var section = footer.querySelector('.section');
      var content = footer.querySelector('.footer-content');
      if (!content) return;

      var children = Array.prototype.slice.call(content.children);
      var brand = children[0];
      var support = topChild(content, findByText(content, 'MAY WE HELP YOU?')) || children[1];
      var company = topChild(content, findByText(content, 'THE COMPANY')) || children[2];
      var group = children[3];
      var groupContent = group && group.querySelector('.group-block-content');
      var scope = groupContent || group || content;
      var newsletterText = topChild(scope, findByText(scope, 'SIGN UP FOR ZOALIN UPDATES'));
      var socialHeading = topChild(scope, findByText(scope, 'FOLLOW ZOALIN'));
      var social = topChild(scope, scope && scope.querySelector('.social-icons__wrapper'));
      var localization = topChild(scope, scope && scope.querySelector('.zoalin-localization'));
      var email = topChild(scope, scope && (scope.querySelector('.email-signup-block') || scope.querySelector('form') || scope.querySelector('input[type="email"]')));
      var narrow = window.innerWidth < 375;

      setImportant(footer, {
        background: '#000',
        color: '#fff',
        height: 'auto',
        'min-height': '0',
        overflow: 'hidden'
      });

      setImportant(section, {
        width: '100%',
        'max-width': 'none',
        height: 'auto',
        'min-height': narrow ? '430px' : '453px',
        margin: '0 auto',
        padding: narrow ? '62px 18px 46px' : '62px 28px 46px',
        background: '#000',
        'box-sizing': 'border-box',
        'grid-template-columns': 'var(--full-page-grid-with-margins)'
      });

      setImportant(content, {
        contain: 'none',
        'content-visibility': 'visible',
        display: 'grid',
        'grid-column': '2',
        'grid-template-columns': 'minmax(0,.98fr) minmax(0,.98fr) minmax(88px,.74fr)',
        'column-gap': narrow ? '13px' : '16px',
        'row-gap': '0',
        width: '100%',
        'max-width': '430px',
        'min-height': '345px',
        margin: '0 auto',
        padding: '0',
        overflow: 'visible',
        'align-items': 'start',
        'justify-content': 'center',
        'text-align': 'left'
      });

      place(brand, '1 / -1', '1');
      setImportant(brand, {
        width: '100%',
        margin: '0 auto 36px',
        'justify-self': 'center',
        'text-align': 'center',
        'align-items': 'center',
        'justify-content': 'center'
      });
      Array.prototype.forEach.call(brand ? brand.querySelectorAll('h2') : [], function (h2) {
        setImportant(h2, {
          display: 'block',
          width: '100%',
          margin: '0 auto',
          color: '#fff',
          'font-size': 'clamp(52px, 13vw, 56px)',
          'font-weight': '760',
          'line-height': '.9',
          'letter-spacing': '0',
          'text-align': 'center'
        });
      });
      Array.prototype.forEach.call(brand ? brand.querySelectorAll('p') : [], function (p) {
        setImportant(p, { display: 'none', visibility: 'hidden' });
      });

      place(support, '1', '2');
      place(company, '2', '2');
      setImportant(group, { display: 'contents' });
      setImportant(groupContent, { display: 'contents' });

      if (newsletterText && newsletterText.parentNode) {
        newsletterText.parentNode.removeChild(newsletterText);
      }

      place(socialHeading, '3', '2');
      setImportant(socialHeading, {
        width: '100%',
        margin: '0',
        'text-align': 'left'
      });

      place(social, '3', '2');
      setImportant(social, {
        display: 'flex',
        'flex-wrap': 'nowrap',
        'align-items': 'center',
        'justify-content': 'flex-start',
        gap: '7px',
        width: 'auto',
        margin: '23px 0 0',
        overflow: 'visible'
      });

      place(localization, '3', '2');
      setImportant(localization, {
        width: '100%',
        'max-width': '100%',
        margin: '62px 0 0'
      });

      place(email, '1 / -1', '3');
      setImportant(email, {
        width: 'min(320px, 86vw)',
        'max-width': '320px',
        height: 'auto',
        'min-height': '48px',
        margin: '22px auto 0',
        'justify-self': 'center'
      });

      Array.prototype.forEach.call(content.querySelectorAll('h3'), function (h3) {
        setImportant(h3, {
          display: 'block',
          margin: '0 0 10px',
          color: '#777',
          'font-size': narrow ? '6.6px' : '7px',
          'font-weight': '760',
          'line-height': '1.15',
          'letter-spacing': '.08em',
          'text-align': 'left',
          'text-transform': 'uppercase',
          'white-space': 'nowrap'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('p, a'), function (el) {
        setImportant(el, {
          margin: '0 0 5px',
          color: '#fff',
          'font-size': narrow ? '6.6px' : '7px',
          'line-height': '1.28',
          'letter-spacing': '0',
          'text-align': 'left',
          'white-space': 'normal'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.social-icons__icon-wrapper, .social-icons__icon-wrapper a, .social-icons__icon'), function (el) {
        setImportant(el, {
          width: '15px',
          'min-width': '15px',
          height: '15px',
          'min-height': '15px',
          'line-height': '0'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.social-icons__icon-label'), function (el) {
        setImportant(el, { display: 'none' });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.zoalin-localization, .zoalin-localization *'), function (el) {
        if (el.closest && el.closest('.zoalin-localization__dialog')) return;
        setImportant(el, {
          'font-size': narrow ? '6.6px' : '7px',
          'line-height': '1.25'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.zoalin-localization__eyebrow'), function (el) {
        setImportant(el, {
          display: 'block',
          margin: '0 0 5px',
          color: '#fff',
          'font-size': narrow ? '6.6px' : '7px'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.zoalin-localization__trigger'), function (el) {
        setImportant(el, {
          'min-height': '24px',
          height: '24px',
          padding: '0 6px',
          'font-size': narrow ? '6.6px' : '7px'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.zoalin-localization__trigger .icon-flag'), function (el) {
        setImportant(el, { width: '12px', height: '8px' });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.email-signup__form, .email-signup__input-group'), function (el) {
        setImportant(el, {
          width: '100%',
          'min-height': '48px',
          height: '48px',
          'align-items': 'center'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('input[type="email"]'), function (el) {
        setImportant(el, {
          'min-height': '46px',
          height: '46px',
          'font-size': '8px',
          'padding-left': '22px',
          'padding-right': '58px'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.email-signup__button'), function (el) {
        setImportant(el, {
          display: 'flex',
          'align-items': 'center',
          'justify-content': 'center',
          width: '40px',
          'min-width': '40px',
          height: '40px',
          'min-height': '40px',
          margin: '3px 4px 3px 0'
        });
      });

      Array.prototype.forEach.call(content.querySelectorAll('.email-signup__button-icon'), function (el) {
        setImportant(el, {
          width: '20px',
          'min-width': '20px',
          height: '20px',
          'min-height': '20px'
        });
      });
    });
  }

  function applyHomeDrawerLogo() {
    if (!mq.matches || !document.body || !document.body.classList.contains('template-index')) return;

    var open = document.body.classList.contains('zoalin-menu-drawer-open') ||
      !!document.querySelector('#Details-menu-drawer-container[open], #Details-menu-drawer-container.menu-open');
    if (!open) return;

    var head = document.querySelector('#Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head');
    var logo = document.querySelector('#Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-logo');
    var actions = document.querySelector('#Details-menu-drawer-container > .menu-drawer > .zoalin-menu-drawer-head .zoalin-menu-drawer-actions');

    setImportant(head, {
      display: 'grid',
      'grid-template-columns': 'minmax(0, 1fr)',
      'grid-template-rows': '38px 38px',
      'justify-items': 'start',
      'align-items': 'center',
      gap: '4px',
      'min-height': '98px',
      padding: '11px 58px 10px 18px',
      'box-sizing': 'border-box'
    });

    setImportant(logo, {
      'grid-column': '1',
      'grid-row': '1',
      'justify-self': 'start',
      'align-self': 'center',
      margin: '0 0 0 4px',
      'text-align': 'left',
      transform: 'none'
    });

    setImportant(actions, {
      'grid-column': '1',
      'grid-row': '2',
      'justify-self': 'start',
      'align-self': 'center',
      'justify-content': 'flex-start',
      margin: '0 0 0 4px'
    });

    document.body.dataset.zoalinHomeDrawerLogoLeft = '20260720-footer-fallback';
  }

  function applyInstagramLinkFix() {
    var target = 'https://www.instagram.com/accounts/login/?next=%2Fzoalinlife%2F';
    Array.prototype.forEach.call(document.querySelectorAll('a[href*="instagram.com/zoalinlife"], a[href*="instagram.com/accounts/login/?next=%2Fzoalinlife%2F"]'), function (link) {
      link.setAttribute('href', target);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
      if (!link.getAttribute('aria-label')) {
        link.setAttribute('aria-label', 'ZOALIN on Instagram');
      }
    });
    document.documentElement.dataset.zoalinInstagramLinkFix = '20260725';
  }

  function schedule() {
    applyFooterSize();
    applyHomeDrawerLogo();
    applyInstagramLinkFix();
    [80, 240, 720, 1600, 3200].forEach(function (delay) {
      window.setTimeout(function () {
        applyFooterSize();
        applyHomeDrawerLogo();
        applyInstagramLinkFix();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', function () {
    window.clearTimeout(timer);
    timer = window.setTimeout(schedule, 120);
  });
  document.addEventListener('shopify:section:load', schedule);
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  else if (mq.addListener) mq.addListener(schedule);

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        applyFooterSize();
        applyInstagramLinkFix();
      }, 90);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
